var _g, _path, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemberAnalysis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.68331 0.844211L3.15566 2.32534C1.1413 2.86509 0.305781 4.31209 0.845476 6.32626L2.32506 11.8481C2.86476 13.8623 4.31183 14.6977 6.32619 14.1579L11.8539 12.6768C13.8682 12.1371 14.6985 10.6915 14.1588 8.6773L12.6792 3.15542C12.1395 1.14125 10.6977 0.304465 8.68331 0.844211Z",
    fill: "url(#paint0_linear_9308_7406)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_9308_7406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33349 3.29002L4.6799 4.269C3.34847 4.62575 2.78647 5.54577 3.12598 6.81283L4.05675 10.2865C4.39625 11.5536 5.34297 12.0693 6.6744 11.7126L10.328 10.7336C11.6594 10.3768 12.2179 9.45774 11.8784 8.19068L10.9477 4.71702C10.6082 3.44996 9.66492 2.93326 8.33349 3.29002Z",
    fill: "#FF5563"
  })))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.388627,
    y: -0.389115,
    width: 20.5282,
    height: 20.5282
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.99px)",
      clipPath: "url(#bgblur_0_9308_7406_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 3.97359,
    d: "M12.5337 3.66699C13.592 3.66699 14.4816 4.03885 15.106 4.69238C15.73 5.34558 16.0835 6.27402 16.0835 7.37598V12.3799C16.0835 13.4786 15.7298 14.4052 15.106 15.0576C14.4816 15.7104 13.592 16.083 12.5337 16.083H7.22314C6.16518 16.083 5.27477 15.711 4.64893 15.0586C4.0233 14.4062 3.66748 13.479 3.66748 12.3799V7.37598C3.66749 6.27392 4.02331 5.34554 4.64893 4.69238C5.27479 4.03917 6.16514 3.66704 7.22314 3.66699H12.5337Z",
    fill: "#FF3949",
    fillOpacity: 0.2,
    stroke: "url(#paint1_linear_9308_7406)",
    strokeWidth: 0.165566,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 13.2666,
    y: 0.366605,
    width: 6.76703,
    height: 6.76703
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.24px)",
      clipPath: "url(#bgblur_1_9308_7406_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 2.48349,
    d: "M16.6501 2.8501C16.1531 2.8501 15.7501 3.25304 15.7501 3.7501C15.7501 4.24715 16.1531 4.6501 16.6501 4.6501C17.1472 4.6501 17.5501 4.24715 17.5501 3.7501C17.5501 3.5114 17.4553 3.28248 17.2865 3.1137C17.1177 2.94492 16.8888 2.8501 16.6501 2.8501Z",
    fill: "url(#paint2_linear_9308_7406)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 4.17044,
    y: 5.56289,
    width: 11.4844,
    height: 8.9018
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.24px)",
      clipPath: "url(#bgblur_2_9308_7406_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_9308_7406)",
    "data-figma-bg-blur-radius": 2.48349
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0799 8.79036L11.3295 11.0491C11.2559 11.1473 11.1454 11.2114 11.0235 11.2266C10.9016 11.2418 10.7788 11.2069 10.6832 11.1298L9.00279 9.81219L7.48934 11.7698C7.37975 11.9438 7.16629 12.022 6.96998 11.9601C6.77367 11.8981 6.64402 11.7116 6.65452 11.5063C6.65362 11.4047 6.68786 11.3059 6.75147 11.2266L8.56115 8.89254C8.63391 8.79515 8.74289 8.73113 8.86349 8.71494C8.98409 8.69875 9.10613 8.73175 9.20207 8.80649L10.8825 10.1295L12.3582 8.23104C12.4292 8.13316 12.5368 8.06818 12.6566 8.05095C12.7764 8.03372 12.898 8.06571 12.9938 8.13961C13.1916 8.2943 13.2298 8.57824 13.0799 8.7796V8.79036Z",
    fill: "url(#paint3_linear_9308_7406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6617 8.0835C12.7724 8.0677 12.8848 8.09736 12.9733 8.16553C13.1569 8.30915 13.1925 8.57332 13.0533 8.76025L13.0465 8.76904V8.77881L11.3033 11.0288C11.2351 11.1198 11.1322 11.1797 11.0192 11.1938C10.9346 11.2044 10.8496 11.1884 10.775 11.1499L10.7037 11.104L9.02307 9.78564L8.9967 9.76514L8.9762 9.7915L7.4635 11.7495L7.46155 11.7524C7.35998 11.9136 7.16202 11.9856 6.9801 11.9282C6.79826 11.8708 6.67757 11.6984 6.68713 11.5083H6.68811V11.5063C6.68727 11.4125 6.71829 11.3208 6.77698 11.2476L6.77795 11.2466L8.58752 8.9126C8.65494 8.82236 8.75604 8.76258 8.8678 8.74756C8.9516 8.73631 9.03642 8.75052 9.11096 8.7876L9.18127 8.83252L10.8619 10.1558L10.8883 10.1763L10.9088 10.1499L12.3844 8.25146L12.3854 8.25049C12.4511 8.15995 12.5509 8.09944 12.6617 8.0835Z",
    stroke: "url(#paint4_linear_9308_7406)",
    strokeWidth: 0.0662265
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7406",
    x: 0.21455,
    y: 0.365063,
    width: 14.5757,
    height: 14.2726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40731,
    result: "effect1_foregroundBlur_9308_7406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7406_clip_path",
    transform: "translate(0.388627 0.389115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5337 3.66699C13.592 3.66699 14.4816 4.03885 15.106 4.69238C15.73 5.34558 16.0835 6.27402 16.0835 7.37598V12.3799C16.0835 13.4786 15.7298 14.4052 15.106 15.0576C14.4816 15.7104 13.592 16.083 12.5337 16.083H7.22314C6.16518 16.083 5.27477 15.711 4.64893 15.0586C4.0233 14.4062 3.66748 13.479 3.66748 12.3799V7.37598C3.66749 6.27392 4.02331 5.34554 4.64893 4.69238C5.27479 4.03917 6.16514 3.66704 7.22314 3.66699H12.5337Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7406_clip_path",
    transform: "translate(-13.2666 -0.366605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6501 2.8501C16.1531 2.8501 15.7501 3.25304 15.7501 3.7501C15.7501 4.24715 16.1531 4.6501 16.6501 4.6501C17.1472 4.6501 17.5501 4.24715 17.5501 3.7501C17.5501 3.5114 17.4553 3.28248 17.2865 3.1137C17.1177 2.94492 16.8888 2.8501 16.6501 2.8501Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_9308_7406",
    x: 4.17044,
    y: 5.56289,
    width: 11.4844,
    height: 8.9018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.827831,
    dy: 0.827831
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.827831
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.321569 0 0 0 0 0.54902 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_9308_7406_clip_path",
    transform: "translate(-4.17044 -5.56289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0799 8.79036L11.3295 11.0491C11.2559 11.1473 11.1454 11.2114 11.0235 11.2266C10.9016 11.2418 10.7788 11.2069 10.6832 11.1298L9.00279 9.81219L7.48934 11.7698C7.37975 11.9438 7.16629 12.022 6.96998 11.9601C6.77367 11.8981 6.64402 11.7116 6.65452 11.5063C6.65362 11.4047 6.68786 11.3059 6.75147 11.2266L8.56115 8.89254C8.63391 8.79515 8.74289 8.73113 8.86349 8.71494C8.98409 8.69875 9.10613 8.73175 9.20207 8.80649L10.8825 10.1295L12.3582 8.23104C12.4292 8.13316 12.5368 8.06818 12.6566 8.05095C12.7764 8.03372 12.898 8.06571 12.9938 8.13961C13.1916 8.2943 13.2298 8.57824 13.0799 8.7796V8.79036Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7406",
    x1: 12.1949,
    y1: 1.59062,
    x2: 0.960551,
    y2: 9.18681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7406",
    x1: 5.70049,
    y1: 5.17714,
    x2: 13.5147,
    y2: 14.8552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7406",
    x1: 16.7826,
    y1: 3.87063,
    x2: 15.201,
    y2: 4.63966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF759F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF196E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7406",
    x1: 12.7093,
    y1: 8.75692,
    x2: 5.4629,
    y2: 9.14827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9308_7406",
    x1: 7.6914,
    y1: 8.50479,
    x2: 9.71397,
    y2: 12.6541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberAnalysis);
export default __webpack_public_path__ + "static/media/memberAnalysis.e708e8c290a7a72eccd3fb37aa39225d.svg";
export { ForwardRef as ReactComponent };